import createRegistry from './factory';
export default {
    default: createRegistry(),
    byName: createRegistry,
};
